var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"orders"},[_c('div',{staticClass:"orders--title"},[_vm._v("Información de tus pedidos")]),_c('div',{staticClass:"orders-list"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }